export default {
  USER_LOAD: 'User/LOAD'
} as const
